export { AttachmentFile as default } from 'choerodon-ui/dataset';
